export default __webpack_public_path__ + "static/media/FontsFree-Net-Jeko-Regular.a695a533.ttf";